import { Flex, Input } from "@chakra-ui/react";
import Fieldset from "../../../general/form/Fieldset";

const OnboardingStep31 = ({ formData, handleChange }) => {
  return (
    <>
      <Flex direction="column" gap={8}>
  <h6>Key service providers</h6>
  <Flex direction="column">
    <Fieldset
      label="Depositary bank"
      description="Provide the name of the bank that will hold and safeguard the fund's assets."
      input={
        <Input
          name="depositaryBank"
          placeholder="Enter depositary bank"
          value={formData.depositaryBank || ""}
          onChange={handleChange}
        />
      }
    />
    <Fieldset
      label="Auditor"
      description="Specify the auditing firm responsible for conducting regular audits of the fund’s financial statements."
      input={
        <Input
          name="auditor"
          placeholder="Enter auditor name"
          value={formData.auditor || ""}
          onChange={handleChange}
        />
      }
    />
    <Fieldset
      label="Fund administrator"
      description="Enter the name of the administrator responsible for managing the daily operations of the fund."
      input={
        <Input
          name="fundAdministrator"
          placeholder="Enter fund administrator"
          value={formData.fundAdministrator || ""}
          onChange={handleChange}
        />
      }
    />
    <Fieldset
      label="Transfer agent"
      description="Name the agent handling shareholder records and fund transactions."
      input={
        <Input
          name="transferAgent"
          placeholder="Enter transfer agent"
          value={formData.transferAgent || ""}
          onChange={handleChange}
        />
      }
    />
    <Fieldset
      label="Valuation agent"
      description="Specify the agent responsible for determining the fair value of the fund's assets."
      input={
        <Input
          name="valuationAgent"
          placeholder="Enter valuation agent"
          value={formData.valuationAgent || ""}
          onChange={handleChange}
        />
      }
    />
    <Fieldset
      label="PM agent"
      description="Indicate the agent responsible for portfolio management."
      input={
        <Input
          name="pmAgent"
          placeholder="Enter PM agent"
          value={formData.pmAgent || ""}
          onChange={handleChange}
        />
      }
    />
  </Flex>
</Flex>


    
    </>
  );
};

export default OnboardingStep31;
